<template>
  <page-outline :title="activateSpinner ? '' : $t('common.security.certificat')">
      <template #pageContent>
        <b-container fluid>
          <!-- ACTION BAR -->
          <b-row>
            <b-col cols="12" class="d-flex justify-content-end mt-3">
              <!-- Filter toggle -->
              <b-button class="btnFilter_2 mr-2 w-100" @click="displayFilter = !displayFilter">
                <i v-if="displayFilter" class="fa-light fa-minus"></i>
                <i v-else class="fa-light fa-plus"></i>
                {{ $t('filter.fltr') }}
              </b-button>
              <!-- Refresh -->
              <b-button class="btnFilter_2 w-100" @click="onRefresh">
                <i class="fa-light fa-rotate-right"></i>
                {{ $t('common.rfrsh') }}
              </b-button>
            </b-col>
          </b-row>

          <hr class="mx-auto" />

          <!-- FILTERS -->
          <b-row v-if="displayFilter" class="min-w-100 justify-content-start align-items-center">
            <b-col cols="3">
              <span class="filter-item-title d-block mb-1">{{ $t('common.security.company') }}</span>
              <input v-model.trim="companyName" class="filter-item-content w-100" style="padding: 0.35rem 0.5rem 0.35rem 0.7rem;" :placeholder="$t('common.security.company')" />
            </b-col>

            <b-col cols="3">
              <span class="filter-item-title d-block mb-1">{{ $t('common.security.active') }}</span>
              <select v-model="Status" class="filter-item-content w-100" style="padding:0.35rem">
                <option value="All">──────────</option>
                <option v-for="s in statuses" :key="s.value" :value="s.value">{{ $t(s.label) }}</option>
              </select>
            </b-col>

            <b-col cols="3">
              <div>
                <span class="filter-item-title d-block mb-1">{{ $t('common.security.startDateExpiration') }}</span>
                <datetime-picker-custom
                  format="YYYY-MM-DD"
                  periodFull
                  id="filter-datebegin"
                  class="mr-3"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': startDateExpiration}"
                  customInputParentClass="filter-item-content"
                  customInputClass="w-100"
                  style="padding:0.35rem"
                  :maxLength="19"
                  :placeholderValue="$t('common.datepicker_format_date3')"
                  inputIcon="fa-solid fa-calendar"
                  :showTime="false"
                  v-model="startDateExpiration"/>
              </div>
            </b-col>

            <b-col cols="3">
              <div>
                <span class="filter-item-title d-block mb-1">{{ $t('common.security.endDateExpiration') }}</span>
                <datetime-picker-custom
                  format="YYYY-MM-DD"
                  periodFull
                  id="filter-datebegin"
                  class="mr-3"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': endDateExpiration}"
                  customInputParentClass="filter-item-content"
                  customInputClass="w-100"
                  style="padding:0.35rem"
                  :maxLength="19"
                  :placeholderValue="$t('common.datepicker_format_date3')"
                  inputIcon="fa-solid fa-calendar"
                  :showTime="false"
                  v-model="endDateExpiration"/>
              </div>
            </b-col>

            <b-col cols="3">
              <span class="filter-item-title d-block mb-1">{{ $t('common.security.cn') }}</span>
              <input v-model.trim="cn" class="filter-item-content w-100" style="padding: 0.35rem 0.5rem 0.35rem 0.7rem;" :placeholder="$t('common.security.cn')" />
            </b-col>

            <b-col cols="12" class="d-flex justify-content-end mt-3">
              <b-button class="btnFilter_2 mr-2 w-100" @click="clearFilterFields" :disabled="!hasInputFilter">
                {{ $t('common.rst') }}
              </b-button>
              <b-button class="btnFilter_2 w-100" @click="onRefresh">
                {{ $t('common.srch') }}
              </b-button>
            </b-col>
          </b-row>

          <hr class="mx-auto mb-4" v-if="displayFilter"/>
          <!-- TABLE -->
          <b-row>
            <b-col cols="12" class="mx-auto mb-4">
              <div style="overflow:auto">
                <spinner v-if="activateSpinner"></spinner>
                <b-table v-else-if="listItemsCertificate.length > 0"
                  hover
                  striped
                  responsive
                  class="table table-striped"
                  style="margin-bottom:0"
                  :items="listItemsCertificate"
                  :fields="fields"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDir"
                  @head-clicked="sortTable"
                  :key="refreshKey"
                  :empty-text="$t('common.security.no_result')">
                  <template #cell(startDate)="data">
                    <span v-if="data.value !== ''"> {{ formatDate(data.value) }}</span>
                    <span v-else>-</span>
                  </template>
                  <template #cell(endDate)="data">
                    <span v-if="data.value !== ''"> {{ formatDate(data.value) }}</span>
                    <span v-else>-</span>
                  </template>
                  <template #cell(active)="data">
                    <div v-if="data.value === '0'">
                      <i class="fa-duotone fa-xmark btn btn-icon btn-icon-red"></i>
                    </div>
                    <div v-else-if="data.value === '1'">
                      <i class="fa-duotone fa-warning btn btn-icon btn-icon-orange"></i>
                    </div>
                    <div v-else-if="data.value === '2'">
                      <i class="fa-duotone fa-check btn btn-icon btn-icon-green"></i>
                    </div>
                  </template>
                  <template #cell(action)="data">
                    <span
                      class="text-center d-inline-block py-4 w-100 action-eye cursor-pointer"
                      @click="showCertificate($event, data.item)"
                      :title="$t('common.security.view_cert')"
                    >
                      <i class="fa-regular fa-eye"></i>
                    </span>
                  </template>
                </b-table>
                <div v-else class="d-flex justify-content-center">
                  <span class="noResult">
                    {{ $t('common.no_result') }}
                  </span>
                </div>
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col>
              <cm-pagination
                :maxResultsByPage="paginationObject.maxResults"
                :firstIndex="paginationObject.firstIndex"
                :nbResultsTotal="paginationObject.nbResultsTotal"
                :refreshEvent="paginationObject.refresh">
              </cm-pagination>
            </b-col>
          </b-row>
        </b-container>
      </template>
  </page-outline>
</template>

<script>
import PageOutline from '@/components/common/PageOutline.vue'
import dateTimePicker from '@/components/common/dateTimePicker.vue'
import Spinner from "@/components/common/spinner.vue"
import Pagination from '@/components/common/pagination.vue'
import { errorMessageAlert } from "@/helpers/alert"
import { loadPage } from "@/helpers/routing"
import moment from 'moment-timezone'

export default {
  name: 'CertificatsListPage',
  components: {
    'page-outline': PageOutline,
    'datetime-picker-custom': dateTimePicker,
    spinner: Spinner,
    'cm-pagination': Pagination,
  },
  data () {
    return {
      activateSpinner: false,
      CertificateListExport: {},
      dateBeginFilter: null,
      dateEndFilter: null,
      displayFilter: false,
      fields: [
        { key: 'companyName', label: this.$t('common.security.company'), class:'text-center', sortable: true },
        { key: 'active', label: this.$t('common.security.active'), class:'text-center', sortable: true },
        { key: 'startDate', label: this.$t('common.security.startDate'), class:'text-center', sortable: true },
        { key: 'endDate', label: this.$t('common.security.endDate'), class:'text-center', sortable: true },
        { key: 'cn', label: this.$t('common.security.cn'), class:'text-center', sortable: true },
        { key: 'userApi', label: this.$t('common.security.user_client_id'), class:'text-center', sortable: true },
        { key: 'action', label: this.$t('common.security.action'), class:'text-center', sortable: false }
      ],
      filterConditions: {},
      listItemsCertificate: [],
      pageCounter: 0,
      paginationObject: {},
      refreshKey: false,
      sortBy: '',
      sortDir: false,
      Status: 'All',
      statuses: [
        { value: 0, label: 'administration.no' },
        { value: 1, label: 'common.security.not_started_yet' },
        { value: 2, label: 'administration.yes' }
      ],
      timezone: '+00:00',
      companyName: '',
      cn: '',
      startDateExpiration: null,
      endDateExpiration: null
    }
  },
  created() {
    this.timezone = moment.tz.guess()

    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
    }
    // this.activateSpinner = true

    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 15
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.getCertificate(index)
      that.pageCounter = 0
    })

    this.pageCounter = 0
    this.onRefresh()
  },
  computed: {
    hasInputFilter () {
      return !!this.companyName || this.Status !== 'All' || this.cn || this.startDateExpiration || this.endDateExpiration
    }
  },
  methods: {
    applyFilter(filterConditions = {}) {
      this.filterConditions = filterConditions

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.getCertificate()
    },
    clearFilterFields () {
      this.companyName = ''
      this.Status = 'All'
      this.cn = ''
      this.startDateExpiration = null
      this.endDateExpiration = null
    },
    formatDate(dateIso) {
      if (!dateIso) return ""
      const s = String(dateIso)
      // Cas classique: "YYYY-MM-DDTHH:mm:ss"
      if (s.includes("T")) {
        return s.split("T")[0]
      }
      // Cas où backend envoie déjà juste la date
      if (s.includes(" ")) {
        return s.split(" ")[0]
      }
      return s
    },
    getCertificate(index = 1) {
      this.pageCounter = 0
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0
      let that = this
      const statusValue =
        this.Status === 'All' || this.Status === '' || this.Status == null
          ? ''
          : this.Status
      let params = {
        companyName: this.companyName,
        status: statusValue,
        cn: this.cn,
        startDateExpiration: this.startDateExpiration,
        endDateExpiration: this.endDateExpiration,
        maxResults: this.paginationObject.maxResults,
        firstIndex: this.paginationObject.firstIndex
      }
      if (this.filterConditions.OrderByField) {
        params.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        params.OrderByDirection = this.filterConditions.OrderByDirection
      }
      this.$engine.security.certificates.fetch(params).then((resp) => {
        that.paginationObject.nbResultsTotal = resp.data.total
        that.paginationObject.nbResults = resp.data.certificates.length

        let CertificateList = {}

        CertificateList = resp.data.certificates

        that.updateCertificate(CertificateList)

        this.$f7.pullToRefreshDone()
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    onRefresh() {
      this.refreshKey = !this.refreshKey
      this.activateSpinner = true
      this.getCertificate()
    },
    refreshList () {
      this.page = 1
      this.transactions = this.transactions.slice() // re-render
      this.applyFilter()
    },
    showCertificate ($e, company) {
      $e.stopPropagation()

      const certificate = company.certificate || 'Aucun certificat disponible'

      this.$f7.modal({
        title: company.name || 'Certificate',
        text: `
          <div class="certificate-modal-content">
            <pre class="certificate-content">${certificate}</pre>
          </div>
        `,
        buttons: [
          {
            text: this.$t('common.security.close')
          }
        ]
      })
    },
    sortTable (key, field, event, isFooter) {
      const sortableFields = [
        'companyName',
        'active',
        'startDate',
        'endDate',
        'cn',
        'userApi'
      ]

      if (!sortableFields.includes(key)) {
        return
      }

      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateCertificate(CertificateList) {
      this.listItemsCertificate = CertificateList
    }
  }
}
</script>

<style scoped>
.status-col { width: 180px; }
.chip{
  --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151;
  display:inline-flex; align-items:center; justify-content:center;
  height:28px; min-width:150px; padding:0 .75rem; border-radius:999px;
  font-size:.75rem; font-weight:600; letter-spacing:.2px;
  border:1px solid var(--chip-border); background-color:var(--chip-bg); color:var(--chip-fg); white-space:nowrap;
}
.chip--success{ --chip-border:#16a34a; --chip-bg:rgba(22,163,74,.10); --chip-fg:#166534; }
.chip--warning{ --chip-border:#f59e0b; --chip-bg:rgba(245,158,11,.12); --chip-fg:#92400e; }
.chip--danger{  --chip-border:#ef4444; --chip-bg:rgba(239,68,68,.10); --chip-fg:#991b1b; }
.chip--secondary{ --chip-border:#9ca3af; --chip-bg:rgba(156,163,175,.12); --chip-fg:#374151; }
.chip--info{ --chip-border:#60a5fa; --chip-bg:rgba(96,165,250,.12); --chip-fg:#0b4a6f; }

::v-deep .action-eye {
  cursor: pointer;
}
</style>
<style>

.certificate-modal-content {
  width: 100%;
  text-align: left;
}

.certificate-content {
  max-height: 400px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-all;
  padding: 15px;
  border-radius: 6px;
  font-size: 11px;
  line-height: 1.5;
  text-align: left;
}
</style>
